var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0013 4.66406C12.0013 3.5595 11.1059 2.66406 10.0013 2.66406H4.66797C3.5634 2.66406 2.66797 3.5595 2.66797 4.66406V12.6641C2.66797 13.7687 3.5634 14.6641 4.66797 14.6641H10.0013C11.1059 14.6641 12.0013 13.7687 12.0013 12.6641V4.66406ZM10.668 4.66406C10.668 4.29588 10.3695 3.9974 10.0013 3.9974H4.66797C4.29978 3.9974 4.0013 4.29588 4.0013 4.66406V12.6641C4.0013 13.0323 4.29978 13.3307 4.66797 13.3307H10.0013C10.3695 13.3307 10.668 13.0323 10.668 12.6641V4.66406Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.33333H8.66667C9.03487 1.33333 9.33333 1.03485 9.33333 0.666667C9.33333 0.29848 9.03487 0 8.66667 0H2C0.895433 0 0 0.895433 0 2V11.3333C0 11.7015 0.29848 12 0.666667 12C1.03485 12 1.33333 11.7015 1.33333 11.3333V2C1.33333 1.63181 1.63181 1.33333 2 1.33333Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.e461a5b44f5931b6d8ab2312f90239ce.svg";
export { ForwardRef as ReactComponent };